// ============================================================================
// OBT F2-B — İstemci tarafı cevap doğrulaması (paket-yerel)
// ============================================================================
// İstemci doğrulaması backend'in YERİNE GEÇMEZ; erken UX geri bildirimi içindir.
// Backend her alanı ve completeness'i ayrıca doğrular (son otorite backend).
//
// Gönderim kuralları snapshot modeline göre:
//   • Görünür ZORUNLU (is_required) soru cevaplanmış olmalı.
//   • `photo_required` soru için o soruya bağlı en az bir fotoğraf olmalı.
//   • `document` soru cevaplanamaz (upload ucu yok); ZORUNLU document → submit blok.
// Taslak kaydetme bu kurallarla ENGELLENMEZ (eksik alanla taslak serbest).
// ============================================================================

import {
  QUESTION_TYPE,
  isDocumentQuestion,
  isPhotoQuestion,
  questionNeedsOptions,
} from './responseEnums';
import { MAX_PHOTO_BYTES, ALLOWED_PHOTO_MIME } from './mediaApi';

/** Tek bir sorunun cevabı "dolu" mu? (tipe göre) */
export function isAnswerFilled(question, answer, photoCountForQuestion = 0) {
  const type = question.question_type;
  if (isPhotoQuestion(type)) {
    return photoCountForQuestion > 0;
  }
  if (isDocumentQuestion(type)) {
    // Document cevaplanamaz → asla "dolu" sayılmaz.
    return false;
  }
  if (type === QUESTION_TYPE.BOOLEAN) {
    return answer?.answer_boolean === true || answer?.answer_boolean === false;
  }
  if (questionNeedsOptions(type)) {
    return Array.isArray(answer?.option_values) && answer.option_values.length > 0;
  }
  // text
  return typeof answer?.answer_text === 'string' && answer.answer_text.trim().length > 0;
}

/**
 * Gönderim öncesi tam doğrulama.
 * @param {Array} questions snapshot soruları (display_order ile)
 * @param {Record<string, object>} answersByQuestion question_id → answer
 * @param {Record<string, number>} photoCountByQuestion question_id → foto sayısı
 * @returns {{ok: boolean, errors: string[], documentBlocked: boolean}}
 */
export function validateForSubmit(questions, answersByQuestion, photoCountByQuestion) {
  const errors = [];
  let documentBlocked = false;

  (questions || []).forEach((q, i) => {
    const n = q.display_order != null ? q.display_order + 1 : i + 1;
    const answer = answersByQuestion?.[q.question_id];
    const photoCount = photoCountByQuestion?.[q.question_id] || 0;

    if (isDocumentQuestion(q.question_type)) {
      if (q.is_required) {
        documentBlocked = true;
        errors.push(
          `${n}. soru belge tipinde ve zorunlu; belge yükleme henüz desteklenmediği için gönderilemez.`
        );
      }
      return; // document için başka kontrol yok
    }

    if (q.is_required && !isAnswerFilled(q, answer, photoCount)) {
      errors.push(`${n}. soru zorunlu; lütfen cevaplayın.`);
    }
    // photo_required: cevabın tipi ne olursa olsun en az bir fotoğraf gerekir.
    if (q.photo_required && photoCount < 1) {
      errors.push(`${n}. soru için en az bir fotoğraf eklemelisiniz.`);
    }
  });

  return { ok: errors.length === 0, errors, documentBlocked };
}

/** Yüklenecek fotoğrafın istemci ön-doğrulaması (413/415 erken yakalama). */
export function validatePhotoFile(file) {
  if (!file) return { ok: false, code: 'empty', message: 'Dosya seçilmedi.' };
  if (file.size > MAX_PHOTO_BYTES) {
    return {
      ok: false,
      code: 413,
      message: 'Dosya 10 MB sınırını aşıyor.',
    };
  }
  const mime = (file.type || '').toLowerCase();
  if (!ALLOWED_PHOTO_MIME.includes(mime)) {
    return {
      ok: false,
      code: 415,
      message: 'Desteklenmeyen fotoğraf türü (yalnız JPEG/PNG/WebP).',
    };
  }
  return { ok: true };
}

/** Filtre dışı park önerisi istemci doğrulaması. */
export function validateSuggestion({ parkId, description, files }) {
  const errors = [];
  if (!parkId) errors.push('Park seçilmelidir.');
  if (!description || !description.trim()) {
    errors.push('Öneri açıklaması zorunludur.');
  } else if (description.trim().length > 2000) {
    errors.push('Açıklama 2000 karakteri aşamaz.');
  }
  if (!Array.isArray(files) || files.length === 0) {
    errors.push('En az bir fotoğraf eklenmelidir.');
  }
  return { ok: errors.length === 0, errors };
}
